import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({spacing, palette}: Theme) => createStyles({
    container: {
        width: "100%",
        padding: spacing.unit * 5,
        boxSizing: "border-box",
        backgroundColor: palette.primary.light,
    },
    content: {
        maxWidth: 1024,
        marginLeft: "auto",
        marginRight: "auto",
    },
    text: {
        paddingLeft: spacing.unit * 4,
        "& > div": {
            marginTop: spacing.unit * 2,
        },
        "& ul" : {
            paddingLeft: spacing.unit * 2,
            marginTop: 0
        }
    },
    headline: {
        fontWeight: 600,
    }
});


// WEBPACK FOOTER //
// ./src/components/Summary/Summary.style.tsx